<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[postingItems$, serviceItems$]"
    [loading]="serviceItemHistoryDataService.loading$ | async"></ef-loading-container>
<div class="card">
    <p-accordion [multiple]="true" (activeIndexChange)="handleOnOpen($event)" [(activeIndex)]="activeIndex">
        <!-- this is implemented in account allocations so will likely never need to be turned on here-->
        <p-accordionTab *featureFlag="'postingItem'" [selected]="true" header="Posting Items">
            <ef-posting-item [items]="postingItems$ | async" [serviceItems]="serviceItems$ | async"
                [selectedError]="selectedErrorWithStatus$ | async"
                (SaveServiceItemPostingType)="onSavePostingType($event)"></ef-posting-item>
        </p-accordionTab>
        <p-accordionTab [selected]="true" header="Service Items">
            <div [ngStyle]="{ height: tabHeight }">
                <ef-service-item [items]="serviceItems$ | async" [selectedError]="selectedErrorWithStatus$ | async"
                    [serviceItemsSelectItems]="serviceItemsSelectItems$ | async" (SelectItem)="onSelect($event)"
                    (ShowError)="onShowError($event)" (Save)="onSave($event)"></ef-service-item>
            </div>
        </p-accordionTab>
        <p-accordionTab [selected]="true" header="Service Item History">
            <!-- should move this to its own component -->
             <p-toolbar>
                <button id="btnClearFilters" pButton pRipple text severity="info" type="button" aria-label="Clear Filter" #clearFilters label="Clear"></button>
                <p-floatLabel variant="on">
                    <p-datepicker #filterDates [monthNavigator]="true" [yearNavigator]="true" [yearRange]="
                        moment().add(-10, 'year').format('YYYY') +
                        ':' +
                        moment().add(10, 'year').format('YYYY')
                    " appendTo="body" selectionMode="range" [(ngModel)]="historyDates"
                        (ngModelChange)="onHistoryDatesChanged()"></p-datepicker>
                    <label for="float-dd">History Date Range</label>
                </p-floatLabel>
                <button pButton pRipple [disabled]="(SelectItemSubject.asObservable() | async)?.length < 1" type="button" label="Sync Service Item Rates" severity="primary" icon="fa fa-refresh"
                    title="Select items in service items filter to enable sync"
                    (click)="SyncServiceitemsSubject.next()"></button>
             </p-toolbar>

            <div [ngStyle]="{ height: tabHeight }">
                <ef-service-item-history [items]="serviceItemHistories$ | async"
                    (Save)="onSaveServiceItemHistory($event)"></ef-service-item-history>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>
